import { computed, onUnmounted, ref, watch } from "vue";

import { storeToRefs } from "pinia";

import { sleep } from "@/helpers/common";
import { useAiAgentsStore } from "@/stores/ai/agents";

export const useFilePreview = () => {
  const aiAgentsStore = useAiAgentsStore();
  const { agentSessionInfo } = storeToRefs(aiAgentsStore);

  const showPreviewModal = ref(false);
  const previewFile = ref<File | null>(null);
  const previewUrl = ref("");

  const openPreview = (file: File) => {
    previewFile.value = file;
    showPreviewModal.value = true;
  };

  const closePreview = () => {
    showPreviewModal.value = false;
  };

  const previewItem = computed(() => {
    if (!previewFile.value) {
      return null;
    }
    return {
      original_name: previewFile.value.name,
      file_url: previewUrl.value,
      mime_type: previewFile.value.type,
    };
  });

  watch(showPreviewModal, async (newValue) => {
    if (newValue && previewFile.value) {
      previewUrl.value = URL.createObjectURL(previewFile.value);
      agentSessionInfo.value.hasActiveOverlay = true;
      return;
    }
    if (previewUrl.value) {
      URL.revokeObjectURL(previewUrl.value);
      previewUrl.value = "";
    }
    await sleep(100);
    agentSessionInfo.value.hasActiveOverlay = false;
  });

  onUnmounted(() => {
    if (previewUrl.value) {
      URL.revokeObjectURL(previewUrl.value);
    }
  });

  return {
    showPreviewModal,
    previewItem,
    openPreview,
    closePreview,
  };
};
